// emailSubscriptions/reducer.js

import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import genericCollectionUtils from '@nhl/generic-collection-utils';

import { teamFilterReducerFactories } from 'media-base-ui/redux/utils';

import actionTypes from './actionTypes';
import subscriptionOptions from './subscriptionOptions';

/* State shape
{
    loadingState: {
        saveState: {
            isLoading: bool,
            success: bool,
            errors: Array
        },
        categoriesState: {
            isLoading: bool,
            success: bool,
            errors: Array
        },
    },
    emailSubscriptionsState: {
        subscriptionFilter: String,
        subscriptionCategories: Array,
        subscriptionTeams: Array
    }
}
*/

const saveStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SAVE)(actionTypes.SAVE_RESPONSE);

const categoriesStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_CATEGORIES)(actionTypes.CATEGORIES_RESPONSE);

const subscriptionFilterReducer = (state = subscriptionOptions.ALL, action) => {
    const { payload } = action;

    switch (action.type) {
        case actionTypes.CHANGE_SUBSCRIPTION_FILTER:
            return payload.value;
        case actionTypes.HYDRATE_SUBSCRIPTIONS:
            return payload.subscriptionFilter;
        default: return state;
    }
};

const subscriptionCategoriesReducer = (state = [], action) => {
    const { payload } = action || {};

    switch (action.type) {
        case actionTypes.CHANGE_SUBSCRIPTION_FILTER:
            switch (payload.value) {
                case subscriptionOptions.ALL:
                    return payload.categoryOptions.slice(0);
                default: return [];
            }
        case actionTypes.CHANGE_CATEGORY_SELECTION:
            return genericCollectionUtils.performAddOrRemoveSelection([...state], payload.id, payload.categoryOptions,
                payload.isChecked);
        case actionTypes.HYDRATE_SUBSCRIPTIONS:
            return payload.subscriptionCategories || [];
        default: return state;
    }
};

const selectedTeamsReducer = teamFilterReducerFactories.selectedTeamsReducerFactory(actionTypes.CHANGE_TEAM_SELECTION)
    (actionTypes.CHANGE_DIVISION_SELECTION)()()()
    (actionTypes.HYDRATE_SUBSCRIPTIONS, actionTypes.CHANGE_SUBSCRIPTION_FILTER);

const categoryTypesReducer = (state = [], action) => {
    if (action.type === actionTypes.CATEGORIES_RESPONSE) {
        return action.payload.categories;
    }

    return state;
};

const emailSubscriptionsReducer = combineReducers({
    subscriptionFilter: subscriptionFilterReducer,
    subscriptionCategories: subscriptionCategoriesReducer,
    selectedTeams: selectedTeamsReducer,
    categoryOptions: categoryTypesReducer
});

const loadingStateReducer = combineReducers({
    saveState: saveStateReducer,
    categoriesState: categoriesStateReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    emailSubscriptionsState: emailSubscriptionsReducer
});

export default reducer;